import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { KitButton } from '../common/MobileKit';
import { KitBanner } from '../common/MobileKitExtras';
import { protoIcon } from '../common/ProtoIcon';
import { MobileAuthPage } from './MobileAuth';

/**
 * Telas de estado no mobile: página não encontrada
 * (`prototipos-mobile/auth/nao-encontrado.html`) e ativação de conta
 * (`auth/ativar-assinatura.html` — a tela real é status loading/sucesso/erro).
 */
const SearchIcon = protoIcon('search');
const Check = protoIcon('check');
const X = protoIcon('x');

function Circle({ children, sx }) {
    return (
        <Box sx={{ width: 72, height: 72, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', m: '0 auto 14px', ...sx }}>{children}</Box>
    );
}

export function MobileNotFound({ to = '/home' }) {
    const navigate = useNavigate();
    return (
        <MobileAuthPage title="Página não encontrada" noBar>
            <Box sx={{ textAlign: 'center', p: '36px 20px', color: 'text.secondary' }}>
                <Circle sx={{ backgroundColor: 'info.bg', color: 'primary.main' }}><SearchIcon size={32} /></Circle>
                <Box component="h3" sx={{ m: '0 0 4px', fontSize: 16, fontWeight: 800, color: 'text.primary', lineHeight: 1.4 }}>Página não encontrada</Box>
                <Box component="p" sx={{ m: '0 0 16px', fontSize: 13, lineHeight: 1.4 }}>O endereço que você abriu não existe ou foi movido.</Box>
                <KitButton variant="primary" onClick={() => navigate(to)}>Ir para o início</KitButton>
            </Box>
        </MobileAuthPage>
    );
}

export function MobileActivation({ isLoading, success, error, onLogin }) {
    return (
        <MobileAuthPage title="Ativar assinatura">
            <Box sx={{ textAlign: 'center', p: '36px 20px', color: 'text.secondary' }}>
                {isLoading && (
                    <>
                        <Circle sx={{ border: '2px dashed', borderColor: 'divider' }}><CircularProgress size={30} sx={{ color: 'primary.main' }} /></Circle>
                        <Box component="h3" sx={{ m: '0 0 4px', fontSize: 16, fontWeight: 800, color: 'text.primary', lineHeight: 1.4 }}>Ativando sua conta</Box>
                        <Box component="p" sx={{ m: 0, fontSize: 13 }}>Aguarde enquanto processamos a ativação…</Box>
                    </>
                )}
                {!isLoading && success && (
                    <>
                        <Circle sx={{ backgroundColor: 'success.main', color: '#fff' }}><Check size={32} /></Circle>
                        <Box component="h3" sx={{ m: '0 0 4px', fontSize: 16, fontWeight: 800, color: 'text.primary', lineHeight: 1.4 }}>Conta ativada com sucesso!</Box>
                        <Box component="p" sx={{ m: 0, fontSize: 13 }}>Você será redirecionado para a página de login em instantes…</Box>
                    </>
                )}
                {!isLoading && !success && error && (
                    <>
                        <Circle sx={{ backgroundColor: 'error.bg', color: 'error.main' }}><X size={32} /></Circle>
                        <Box component="h3" sx={{ m: '0 0 12px', fontSize: 16, fontWeight: 800, color: 'text.primary', lineHeight: 1.4 }}>Erro na ativação</Box>
                        <Box sx={{ textAlign: 'left', mb: '16px' }}><KitBanner tone="danger">{error}</KitBanner></Box>
                        <KitButton variant="primary" block onClick={onLogin}>Voltar para o login</KitButton>
                    </>
                )}
            </Box>
        </MobileAuthPage>
    );
}
